import * as actionTypes from '../config/actionTypes';
import axios from '../config/axios';
import * as constants from '../config/constants';

import { getAuthHeaders } from '../auth/actions';
import {
  changeInputHandler,
  handleFormSubmit,
  updateFieldErrorsHandler,
} from '../common/utility';


export const toggleLoading = () => {
  return {
    type: actionTypes.TOGGLE_MAIN_LOADING,
  };
};


export const toggleMainActionLoading = () => {
  return {
    type: actionTypes.TOGGLE_MAIN_ACTION_LOADING,
  };
};


export const showError = (error) => {
  return {
    type: actionTypes.SHOW_MAIN_ERROR,
    payload: error,
  };
};


export const onUnmount = () => {
  return {
    type: actionTypes.UNMOUNT_MAIN,
  };
};


export const deepUnmount = () => {
  return {
    type: actionTypes.DEEP_UNMOUNT_MAIN,
  };
};


export const showEvents = (data) => {
  return {
    type: actionTypes.SHOW_EVENTS,
    payload: data,
  };
};


export const getEvents = (siteID, url = null) => {
  return (dispatch) => {
    dispatch(toggleLoading());
    let getURL = `/common/get-events?site_id=${siteID}`;
    if (url) {
      getURL = url;
    }

    axios.get(getURL)
      .then((response) => {
        dispatch(toggleLoading());
        dispatch(showEvents(response.data));
      })
      .catch((error) => {
        if (error && error.response && error.response.data && error.response.data.detail) {
          dispatch(showError(error.response.data.detail));
        } else {
          dispatch(showError(constants.DEFAULT_ERROR));
        }
        dispatch(toggleLoading());
      });
  };
};


export const showNews = (data) => {
  return {
    type: actionTypes.SHOW_NEWS,
    payload: data,
  };
};


export const showAlbums = (data) => {
  return {
    type: actionTypes.SHOW_ALBUMS,
    payload: data,
  };
};


export const getNews = (siteID, url = null) => {
  return (dispatch) => {
    dispatch(toggleLoading());

    let getURL = `/common/get-news?site_id=${siteID}`;
    if (url) {
      getURL = url;
    }
    axios.get(getURL)
      .then((response) => {
        dispatch(toggleLoading());
        dispatch(showNews(response.data));
      })
      .catch((error) => {
        if (error && error.response && error.response.data && error.response.data.detail) {
          dispatch(showError(error.response.data.detail));
        } else {
          dispatch(showError(constants.DEFAULT_ERROR));
        }
        dispatch(toggleLoading());
      });
  };
};


export const getAlbums = () => {
  return (dispatch) => {
    dispatch(toggleLoading());

    const getURL = '/common/album-list';
    axios.get(getURL)
      .then((response) => {
        dispatch(toggleLoading());
        dispatch(showAlbums(response.data));
      })
      .catch((error) => {
        if (error && error.response && error.response.data && error.response.data.detail) {
          dispatch(showError(error.response.data.detail));
        } else {
          dispatch(showError(constants.DEFAULT_ERROR));
        }
        dispatch(toggleLoading());
      });
  };
};


export const showEventDetail = (data) => {
  return {
    type: actionTypes.SHOW_EVENT_DETAIL,
    payload: data,
  };
};


export const showNewsDetail = (data) => {
  return {
    type: actionTypes.SHOW_NEWS_DETAIL,
    payload: data,
  };
};


export const getEventItem = (token, slug) => {
  return (dispatch) => {
    dispatch(toggleLoading());
    let headers = {};
    if (token) {
      headers = getAuthHeaders(token);
    }

    const getURL = `/common/get-event-item/${slug}`;
    axios.get(getURL, headers)
      .then((response) => {
        dispatch(toggleLoading());
        dispatch(showEventDetail(response.data));
      })
      .catch((error) => {
        if (error.response.data && error.response.data.detail) {
          dispatch(showError(error.response.data.detail));
        } else {
          dispatch(showError('Something went wrong!'));
        }
        dispatch(toggleLoading());
      });
  };
};


export const getNewsItem = (slug) => {
  return (dispatch) => {
    dispatch(toggleLoading());

    const getURL = `/common/get-news-item/${slug}`;
    axios.get(getURL)
      .then((response) => {
        dispatch(toggleLoading());
        dispatch(showNewsDetail(response.data));
      })
      .catch((error) => {
        if (error.response.data && error.response.data.detail) {
          dispatch(showError(error.response.data.detail));
        } else {
          dispatch(showError('Something went wrong!'));
        }
        dispatch(toggleLoading());
      });
  };
};


export const showActionError = (error) => {
  return {
    type: actionTypes.SHOW_MAIN_ACTION_ERROR,
    payload: error,
  };
};


export const eventJoined = () => {
  return {
    type: actionTypes.EVENT_JOINED,
  };
};


export const updateProfileInputs = (form, data) => {
  return {
    type: actionTypes.UPDATE_MAIN_INPUTS,
    payload: { form: form, data: data }  // eslint-disable-line
  };
};


export const inputChangedHandler = (event, field, form, inputs) => {
  return (dispatch) => {
    const updatedControls = changeInputHandler(
      event,
      inputs,
      field,
    );
    dispatch(updateProfileInputs(form, updatedControls));
  };
};


export const joinEvent = (token, id) => {
  return (dispatch) => {
    dispatch(toggleMainActionLoading());
    axios.post('/common/join-event', { event_id: id }, getAuthHeaders(token))
      .then(() => {
        window.location.reload();
      })
      .catch((error) => {
        if (error.response.data && error.response.data.detail) {
          dispatch(showActionError(error.response.data.detail));
        } else {
          dispatch(showActionError('Something went wrong!'));
        }
        dispatch(toggleMainActionLoading());
      });
  };
};


export const updateFieldErrors = (form, inputs, errorData) => {
  return (dispatch) => {
    const updatedInputs = updateFieldErrorsHandler(inputs, errorData);
    dispatch(updateProfileInputs(form, updatedInputs));
  };
};


export const submitHandler = (event, form, inputs, token, slug) => {
  return (dispatch) => {
    dispatch(toggleMainActionLoading());
    const result = handleFormSubmit(event, inputs);

    if (result.formError) {
      // frontend error
      dispatch(updateProfileInputs(form, result.inputs));
      dispatch(toggleMainActionLoading());
    }

    if (Object.keys(result.fields).length === Object.keys(inputs).length) {
      const url = '/common/join-event';

      const fields = result.fields;  // eslint-disable-line
      fields.event_slug = slug;

      axios.post(url, fields, getAuthHeaders(token))
        .then(() => {
          window.location.reload();
        })
        .catch((error) => {
          if (error.response.status === 400) {
            if (error.response.data.detail) {
              dispatch(showActionError(error.response.data.detail));
            } else {
              dispatch(updateFieldErrors(form, inputs, error.response.data));
            }
          } else {
            dispatch(showActionError('Something went wrong! Please contact tech support!'));
          }
          dispatch(toggleMainActionLoading());
        });
    }
  };
};


export const showSiteSettings = (data) => {
  return {
    type: actionTypes.SHOW_SITE_SETTINGS,
    payload: data,
  };
};


export const getSiteSettings = (siteID) => {
  return (dispatch) => {
    dispatch(toggleLoading());

    const getURL = `/common/get-site-settings?site_id=${siteID}`;
    axios.get(getURL)
      .then((response) => {
        dispatch(toggleLoading());
        dispatch(showSiteSettings(response.data));
      })
      .catch((error) => {
        if (error.response.data && error.response.data.detail) {
          dispatch(showError(error.response.data.detail));
        } else {
          dispatch(showError('Something went wrong!'));
        }
        dispatch(toggleLoading());
      });
  };
};


export const showGalleryDetail = (data) => {
  return {
    type: actionTypes.SHOW_ALBUM_DETAIL,
    payload: data,
  };
};


export const getGalleryItem = (slug) => {
  return (dispatch) => {
    dispatch(toggleLoading());

    const getURL = `/common/photo-list/${slug}`;
    axios.get(getURL)
      .then((response) => {
        dispatch(toggleLoading());
        dispatch(showGalleryDetail(response.data));
      })
      .catch((error) => {
        if (error.response.data && error.response.data.detail) {
          dispatch(showError(error.response.data.detail));
        } else {
          dispatch(showError('Something went wrong!'));
        }
        dispatch(toggleLoading());
      });
  };
};



// WEBPACK FOOTER //
// ./src/main/actions.js